import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'homebox-ui';

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title = '',
  message = '',
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='sm:max-w-[725px]'>
        <DialogHeader>
          <DialogTitle className='text-center'>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className='px-2 py-3'>
          <p className='text-typography-secondary whitespace-pre-line text-center text-base'>
            {message}
          </p>
        </DialogDescription>

        <DialogFooter className='flex flex-col gap-3'>
          <Button
            variant='primary'
            onClick={onConfirm}
            className='w-full text-center'
          >
            I understand, proceed
          </Button>
          <Button
            variant='secondary'
            onClick={onClose}
            className='w-full text-center'
          >
            Choose a different energy option
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
